// extracted by mini-css-extract-plugin
export var chevron = "_mq-4";
export var chevronExpanded = "_mq-5";
export var row = "_mq-0";
export var rowBody = "_mq-6";
export var rowDescription = "_mq-7";
export var rowHeader = "_mq-1";
export var rowTitle = "_mq-2";
export var rowTitleComplete = "_mq-3";